import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useLocation } from 'react-router-dom';
import '../../style/partners.scss';
import { useTranslation } from 'react-i18next';

export const Partners = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();
  const { t } = useTranslation();

  // Set background color based on path
  const bgColor = location.pathname === '/aboutus' ? '#ffffff' : '#d9f3fd';

  // Define a uniform style for mobile logos with a max height
  const mobileLogoStyle = { maxHeight: '50px' };

  return (
    <div className="container-about-us" style={{ backgroundColor: bgColor }}>
      <div className="container">
        {/* Row wrapper to center everything horizontally and vertically */}
        <div className="row justify-content-center align-items-center py-4">
          {/* Desktop layout remains unchanged */}
          {!isMobile ? (
            <div className="d-flex flex-row align-items-center justify-content-center" style={{ gap: '20px' }}>
              <img src="/images/cesty-pathways.png" alt="Cesty Pathways Logo" style={{ maxWidth: '180px' }} />
              <span style={{ color: 'gray', fontFamily: 'Mark-Light', fontSize: '14px' }}>{t('isSupportedBy')}</span>
              <img src="/images/rok.png" alt="Government of the Republic of Korea" style={{ maxWidth: '120px' }} />
              <img src="/images/america.png" alt="Swiss-Europe Rapid Response Fund" style={{ maxWidth: '100px' }} />
              {/* <img src="/images/swissRRF.png" alt="Swiss-Europe Rapid Response Fund" style={{ maxWidth: '250px' }} />
              <img src="/images/EUcofunding.png" alt="Swiss-Europe Rapid Response Fund" style={{ maxWidth: '100px' }} />
              <img
                src="/images/european_bank.png"
                alt="Swiss-Europe Rapid Response Fund"
                style={{ maxWidth: '100px' }}
              /> */}
            </div>
          ) : (
            // Mobile layout with uniform logo sizes using max height
            <div className="d-flex flex-column align-items-center">
              <img
                src="/images/cesty-pathways.png"
                alt="Cesty Pathways Logo"
                style={{ ...mobileLogoStyle, marginBottom: '20px' }}
              />
              <span style={{ color: 'gray', fontFamily: 'Mark-Light', fontSize: '14px', marginBottom: '20px' }}>
                {t('isSupportedBy')}
              </span>
              <div className="d-flex flex-row justify-content-center" style={{ gap: '10px', marginTop: '10px' }}>
                <img src="/images/rok.png" alt="Government of the Republic of Korea" style={{ maxHeight: '60px' }} />
                <img src="/images/america.png" alt="Swiss-Europe Rapid Response Fund" style={{ maxHeight: '40px' }} />
              </div>
              {/* <div className="d-flex flex-row justify-content-center" style={{ gap: '10px', marginTop: '10px' }}>
                <img src="/images/swissRRF.png" alt="Swiss-Europe Rapid Response Fund" style={{ maxHeight: '40px' }} />
                <img
                  src="/images/EUcofunding.png"
                  alt="Swiss-Europe Rapid Response Fund"
                  style={{ maxHeight: '60px' }}
                />
                <img
                  src="/images/european_bank.png"
                  alt="Swiss-Europe Rapid Response Fund"
                  style={{ maxHeight: '60px' }}
                />
              </div> */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
